<template>
  <div v-if="isOpen" class="fixed z-[2000] inset-0 bg-black bg-opacity-50 overflow-auto">
    <transition name="fade-slide">
      <div v-if="openModalContent" class="w-full relative m-auto p-[40px]" :style="{ maxWidth: size }">
        <button class="w-[40px] h-[40px] flex justify-center items-center absolute top-0 right-0" @click="close">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.5 2.5L2.5 13.5" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M2.5 2.5L13.5 13.5" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
        <div class="bg-white rounded shadow-lg overflow-hidden w-full">
          <template v-if="component">
            <component :is="component" :meta="meta"></component>
          </template>
        </div>
        <button
          class="w-[40px] h-[40px] flex justify-center items-center absolute left-0 top-0 bottom-0 m-auto"
          @click="emitLayout('layout:change', 'prev')"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.5 3.5L5 8L9.5 12.5" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
        <button
          class="w-[40px] h-[40px] flex justify-center items-center absolute right-0 top-0 bottom-0 m-auto"
          @click="emitLayout('layout:change', 'next')"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.5 3.5L11 8L6.5 12.5" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'ModalLayout',
  props: {
    component: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: '50%',
    },
    customClass: {
      type: String,
      default: '',
    },
    meta: {
      type: null,
      default: null,
    },
  },
  data() {
    return {
      isOpen: false,
      openModalContent: false,
    }
  },
  watch: {
    isOpen(val) {
      if (val) {
        document.body.classList.add('overflow-hidden')
        this.$emit('modal:open', { event: 'modal:open', value: this.isOpen })
        setTimeout(() => {
          this.openModalContent = true
        }, 100)
      } else {
        document.body.classList.remove('overflow-hidden')
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.isOpen = true
    }, 0)
  },
  methods: {
    close() {
      this.$emit('modal:close', { event: 'modal:close', value: this.isOpen })
      this.openModalContent = false
      setTimeout(() => {
        this.$Modal.destroy()
      }, 300)
    },
    emitLayout(event, value) {
      this.$Modal.instance.$emit('layout:change', { event, value })
    },
  },
}
</script>
<style lang="scss">
.modal {
  .el-dialog__header {
    @apply p-0;
  }
  .el-dialog__body {
    @apply p-0;
  }
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.3s, transform 0.3s; /* Transition duration for fade and slide */
}

.fade-slide-enter {
  opacity: 0; /* Initial state for fade-in */
  transform: translateY(-30px); /* Initial position above */
}

.fade-slide-leave-to {
  opacity: 0; /* Final state for fade-out */
  transform: translateY(-30px); /* Slide out above the screen */
}
</style>
